// Feature flag ids. Each value is the flag's opaque public id from the admin dashboard
// (Feature Flags page → "copy TS constant") — never the flag's name. Production builds
// inline these constants, so the shipped bundle contains only ids like 'k7q2xm9a'; the
// comment with the flag key is stripped by minification.
//
// Keep in sync with weavewords-mobile/src/config/featureFlags.ts.
//
// Usage:
//   const enabled = useFeature(FF_STORY_MODE);
//   <Feature flag={FF_STORY_MODE} fallback={<Old />}><New /></Feature>
//
// Example:
//   export const FF_STORY_MODE = 'k7q2xm9a'; // ai_story_mode

export const FF_LESSON_MODE = 'zybsbitq'; // lesson_mode
export const FF_MCP_SERVER = '3famdxdf'; // mcp_server
